import React from "react";

import { useTranslation, Trans } from "react-i18next";

import i1 from '../../img/Home/i1.png';
import i2 from '../../img/Home/i2.png';
import i3 from '../../img/Home/i3.png';

function InMoment () {

    const { t } = useTranslation();
      
    return(
        <div className="relative pt-[90px] xl:pt-[160px]">
            <div className="max-w-[1220px] xl:mx-auto mx-[20px] relative flex flex-col items-center">
                <p className="spantext text-[#0C2780] font-[700] text-[23px] xl:text-[45px] open-sans"><Trans>{t('home.22')}</Trans></p>
                <div className="grid grid-cols-2 sm:grid-cols-3 mt-[60px] gap-[20px] sm:gap-[60px] md:gap-[120px] xl:gap-[190px]">
                    <div className="flex flex-col items-center">
                        <img src={i1} alt="" />
                        <p className="mt-[9px] font-[700] open-sans text-[#0C2780] text-[14px] xl:text-[16px]">3500</p>
                        <p className="font-[300] open-sans text-[#0C2780] text-[14px] xl:text-[16px]">{t('home.23')}</p>
                    </div>
                    <div className="flex flex-col items-center">
                        <img src={i2} alt="" />
                        <p className="mt-[9px] font-[700] open-sans text-[#0C2780] text-[14px] xl:text-[16px]">75+</p>
                        <p className="font-[300] open-sans text-[#0C2780] text-[14px] xl:text-[16px]">{t('home.24')}</p>
                    </div>
                    <div className="flex flex-col items-center col-span-2 sm:col-span-1 justify-self-center">
                        <img src={i3} alt="" />
                        <p className="mt-[9px] font-[700] open-sans text-[#0C2780] text-[14px] xl:text-[16px]">{t('home.25')}</p>
                        <p className="font-[300] open-sans text-[#0C2780] text-[14px] xl:text-[16px]">{t('home.26')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default InMoment;